// Path: ./src/app/components/AiGenerationEffortColumn/index.tsx

import { GridRenderCellParams } from "@mui/x-data-grid";

/**
 * Builds the Smart Flyer reasoning effort column shared by the Flyers table and
 * the Flyer Item Lists table. The two tables hold the same value at different
 * depths, so the caller passes an accessor that reads it off a row.
 *
 * The column is neither sortable nor filterable: the value lives on the related
 * flyer item list and the list endpoints do not support ordering or filtering
 * on it.
 *
 * @param getEffort - Returns the reasoning effort for a row.
 * @returns The column definition.
 */
export const buildAiGenerationEffortColumn = <RowType extends object>(
  getEffort: (row: RowType) => string | undefined,
) => ({
  field: "aiGenerationEffort",
  width: 110,
  headerName: "Effort",
  sortable: false,
  filterable: false,
  renderCell: (params: GridRenderCellParams<RowType>) => {
    const effort = getEffort(params.row);
    return <div title={effort ?? undefined}>{effort ?? "—"}</div>;
  },
});
